import { useRef, useState, useEffect } from "react";
import "./Home.css";

import group from "./assets/Group.png";
import r1 from "./assets/R1.svg";
import r2 from "./assets/R2.svg";
import r3 from "./assets/R3.svg";
import r4 from "./assets/R4.svg";

const HomeWebsite = () => {
  const [hovered, setHovered] = useState(false);
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const featureData = [
    {
      id: "time-attendance",
      icon: r1,
      title: "Time & Attendance Management",
      text:
        "Automate employee time tracking, reporting, and streamline attendance management for efficiency.",
    },
    {
      id: "employee-self-service",
      icon: r2,
      title: (
        <>
          Employee <br /> Self-Service
        </>
      ),
      text:
        "Enable employees to manage schedules, submit leave requests, and handle approvals digitally.",
    },
    {
      id: "work-allocation",
      icon: r3,
      title: "Automated Work Allocation & Assignment",
      text:
        "Assign tasks efficiently, monitor progress in real time, and ensure timely completion.",
    },
    {
      id: "capacity-planning",
      icon: r4,
      title: "Capacity & Operational Planning",
      text:
        "Optimize resource utilization, balance workload distribution, and enhance overall team productivity effectively.",
    },
  ];

  return (
    <div className="hw-wrapper">
   
      <div className="hw-image-wrapper">
        <img
          src={group}
          alt="Team Discussion"
          className={`hw-image ${hovered ? "hw-image-hovered" : ""}`}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        />
      </div>

     
      <div className="hw-content">
        <h2 className="hw-title">What We Are Proficient At</h2>

       
        <div ref={containerRef} className="hw-grid">
          {featureData.map((feature, index) => (
            <div
              key={feature.id}
              className={`hw-card ${
                visible ? "hw-card-visible" : "hw-card-hidden"
              } hw-delay-${index}`}
            >
              <img src={feature.icon} alt={feature.id} className="hw-icon" />

              <h3 className="hw-card-title">{feature.title}</h3>

              <p className="hw-card-text">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeWebsite;
